'use strict';

var PropTypes = require('prop-types');
var React = require('react');
var styles = {
  facebook: {
    icon: React.createElement("path", {
      d: "M211.9 197.4h-36.7v59.9h36.7V433.1h70.5V256.5h49.2l5.2-59.1h-54.4c0 0 0-22.1 0-33.7 0-13.9 2.8-19.5 16.3-19.5 10.9 0 38.2 0 38.2 0V82.9c0 0-40.2 0-48.8 0 -52.5 0-76.1 23.1-76.1 67.3C211.9 188.8 211.9 197.4 211.9 197.4z"
    }),
    background: "#3B5998"
  },
  "google-plus": {
    icon: React.createElement("path", {
      d: "M179.7 237.6L179.7 284.2 256.7 284.2C253.6 304.2 233.4 342.9 179.7 342.9 133.4 342.9 95.6 304.4 95.6 257 95.6 209.6 133.4 171.1 179.7 171.1 206.1 171.1 223.7 182.4 233.8 192.1L270.6 156.6C247 134.4 216.4 121 179.7 121 104.7 121 44 181.8 44 257 44 332.2 104.7 393 179.7 393 258 393 310 337.8 310 260.1 310 251.2 309 244.4 307.9 237.6L179.7 237.6 179.7 237.6ZM468 236.7L429.3 236.7 429.3 198 390.7 198 390.7 236.7 352 236.7 352 275.3 390.7 275.3 390.7 314 429.3 314 429.3 275.3 468 275.3"
    }),
    background: "#DB4437"
  },
  twitter: {
    icon: React.createElement("path", {
      d: "M419.6 168.6c-11.7 5.2-24.2 8.7-37.4 10.2 13.4-8.1 23.8-20.8 28.6-36 -12.6 7.5-26.5 12.9-41.3 15.8 -11.9-12.6-28.8-20.6-47.5-20.6 -42 0-72.9 39.2-63.4 79.9 -54.1-2.7-102.1-28.6-134.2-68 -17 29.2-8.8 67.5 20.1 86.9 -10.7-0.3-20.7-3.3-29.5-8.1 -0.7 30.2 20.9 58.4 52.2 64.6 -9.2 2.5-19.2 3.1-29.4 1.1 8.3 25.9 32.3 44.7 60.8 45.2 -27.4 21.4-61.8 31-96.4 27 28.8 18.5 63 29.2 99.8 29.2 120.8 0 189.1-102.1 185-193.6C399.9 193.1 410.9 181.7 419.6 168.6z"
    }),
    background: "#1DA1F2"
  },
  pinterest: {
    icon: React.createElement("path", {
      d: "M266.6 76.5c-100.2 0-150.7 71.8-150.7 131.7 0 36.3 13.7 68.5 43.2 80.6 4.8 2 9.2 0.1 10.6-5.3 1-3.7 3.3-13 4.3-16.9 1.4-5.3 0.9-7.1-3-11.8 -8.5-10-13.9-23-13.9-41.3 0-53.3 39.9-101 103.8-101 56.6 0 87.7 34.6 87.7 80.8 0 60.8-26.9 112.1-66.8 112.1 -22.1 0-38.6-18.2-33.3-40.6 6.3-26.7 18.6-55.5 18.6-74.8 0-17.3-9.3-31.7-28.4-31.7 -22.5 0-40.7 23.3-40.7 54.6 0 19.9 6.7 33.4 6.7 33.4s-23.1 97.8-27.1 114.9c-8.1 34.1-1.2 75.9-0.6 80.1 0.3 2.5 3.6 3.1 5 1.2 2.1-2.7 28.9-35.9 38.1-69 2.6-9.4 14.8-58 14.8-58 7.3 14 28.7 26.3 51.5 26.3 67.8 0 113.8-61.8 113.8-144.5C400.1 134.7 347.1 76.5 266.6 76.5z"
    }),
    background: "#BD081C"
  }
};
function getHref(a, b, c, d) {
  var e = encodeURI(b);
  return "facebook" === a ? "https://www.facebook.com/sharer/sharer.php?u=" + e : "google-plus" === a ? "https://plus.google.com/share?url=" + e : "twitter" === a ? "https://twitter.com/intent/tweet?url=" + e + "&text=" + c : "pinterest" === a ? "http://www.pinterest.com/pin/create/button/?url=" + e + "&media=" + d + "&description=" + c : void 0;
}
function getButtonData(a, b, c, d) {
  var e = styles[a].background,
    f = getHref(a, b, c, d);
  return {
    background: e,
    href: f
  };
}
function getIconPath(a) {
  return styles[a].icon || null;
}
function getTextContent(a) {
  return "facebook" === a ? "Facebook" : "google-plus" === a ? "Google Plus" : "twitter" === a ? "Tweet" : "pinterest" === a ? "Pin it" : null;
}
function Icon(a) {
  var b = a.socialMedia;
  return React.createElement("svg", {
    viewBox: "0 0 512 512",
    style: {
      width: "24px",
      height: "24px",
      flex: "none",
      fill: "white",
      marginLeft: "auto",
      marginRight: "auto"
    }
  }, getIconPath(b));
}
function Text(a) {
  var b = a.socialMedia;
  return React.createElement("div", {
    style: {
      flex: "none",
      fontSize: "18px",
      textAlign: "right",
      paddingRight: "10px",
      paddingLeft: "5px"
    }
  }, getTextContent(b));
}
function Wrapper(a) {
  var b = a.children,
    c = a.socialMedia,
    d = a.url,
    e = a.text,
    f = a.media,
    g = getButtonData(c, d, e, f),
    h = g.background,
    i = g.href;
  return React.createElement("a", {
    style: {
      display: "flex",
      minWidth: "32px",
      height: "32px",
      width: "auto",
      alignItems: "center",
      background: h,
      color: "white",
      borderRadius: "5px",
      margin: "0 3px"
    },
    target: "_blank",
    href: i
  }, b);
}
function ShareButton(a) {
  var b = a.compact,
    c = a.media,
    d = a.text,
    e = a.url,
    f = a.socialMedia;
  return f ? React.createElement(Wrapper, {
    socialMedia: f,
    url: e,
    text: d,
    media: c
  }, React.createElement(Icon, {
    socialMedia: f
  }), !b && React.createElement(Text, {
    socialMedia: f
  })) : null;
}
ShareButton.propTypes = {
  compact: PropTypes.bool,
  media: PropTypes.string,
  socialMedia: PropTypes.string.isRequired,
  text: PropTypes.string,
  url: PropTypes.string.isRequired
};
module.exports = ShareButton;